import AxiosInjectClass from './axiosclass';

const AxiosInject = new AxiosInjectClass();
export default AxiosInject;
